import PropTypes from "prop-types";
import { css } from "@emotion/react";

Blank.propTypes = {};

function Blank({ children }) {
  return <div css={blank}>{children}</div>;
}

const blank = (theme) => css`
  height: 100vh;
  width: 100%;
`;

export default Blank;
